import useNotificationSubscription
  from "./notification.subscription"

function NotificationSubscriber() {
  useNotificationSubscription()
  return null
}

export default NotificationSubscriber
